import { Navigate, useRoutes } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
import Page404 from './pages/Page404';
import DashboardAppPage from './pages/DashboardAppPage';
import SignUpForm from './DevelopmentComp/Others/SignUpForm';
import LoginPage from './DevelopmentComp/Others/LoginPage';
import User from './DevelopmentComp/Masters/User';
import Products from './DevelopmentComp/Masters/Products';
import SubCategory from './DevelopmentComp/Masters/SubCategory';
import Category from './DevelopmentComp/Masters/Category';

// ----------------------------------------------------------------------

const isAuthenticated = () => {
  const token = sessionStorage.getItem('authToken');
  return token;
};

const hasAccess = (screenName) => {
  const access = sessionStorage.getItem(`${screenName}`) === 'Y';
  return access;
};

// ProtectedRoute HOC
const ProtectedRoute = ({ element, screenName }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  if (!hasAccess(screenName)) {
    return <Page404 />;
  }
  return element;
};

const ProtectedForViewInspectionRoute = ({ element, screenNames }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  if (!screenNames.map((screenName) => hasAccess(screenName)).includes(true)) {
    return <Page404 />;
  }
  return element;
};

// for  techvel dashboard
export default function Router() {
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: (
        <>
          <Helmet>
            <title>ASK | Website | Dashboard</title>
          </Helmet>
          <DashboardLayout />
        </>
      ),

      children: [
        // Example Route
        { path: 'home', element: <DashboardAppPage />, shortname: 'Dashboard' },
        // Masters Route
        { path: 'masters/Products', element: <Products />, shortname: 'User_Master' },
        { path: 'masters/Category', element: <Category />, shortname: 'User_Master' },
        { path: 'masters/SubCategory', element: <SubCategory />, shortname: 'User_Master' },
        { path: 'masters/User', element: <User />, shortname: 'User_Master' },
      ]
        .map((route) => ({
          ...route,
          element: <ProtectedRoute element={route.element} screenName={route.shortname} />,
        }))
        .concat([{ path: '404', element: <Page404 /> }]),
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="login" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ].map((route) => ({ ...route, element: <ProtectedRoute element={route.element} /> })),
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
    {
      path: 'login',
      element: (
        <>
          <Helmet>
            <title>ASK | Login</title>
          </Helmet>
          <LoginPage />
        </>
      ),
    },
    {
      path: 'signup',
      element: (
        <>
          <Helmet>
            <title>ASK | Sign Up</title>
          </Helmet>
          <SignUpForm />
        </>
      ),
    },
  ]);

  return routes;
}
